import Component from "../../lib/component";
import {CollapserToggle} from "./collapser_toggle";
import {CollapserTarget} from "./collapser_target";

export const CollapserConfig = {
    componentTypeKey: 'Collapser',
    baseHtmlClass: 'collapser',
    selector: '.collapser',
    datasetConfigKey: 'collapser',
};

export class Collapser extends Component {

    static get config() {
        return CollapserConfig;
    }

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: Collapser.config
        });
        this.setDatasetConfig(Collapser.config.datasetConfigKey);

        this.toggles = this.getToggles();
        this.target = this.getTarget();

        this.applyToClass = this.getDatasetConfigValue('apply_to_class');
        this.isOpen = this.getDatasetConfigValue('open') ?? false;
        this.isCollapsable = this.getDatasetConfigValue('collapsable') ?? true;

        this.render();
    }

    render() {
        this.conditionallySetHtmlClassState(this.isCollapsable, 'collapsable');
        this.swapHtmlClassStates(this.isOpen, 'open', 'closed');
        if (!!this.target) this.target.render();
        this.toggles.forEach((toggle) => toggle.render());
        if (this.applyToClass) {
            this.applyToClass.split(' ').forEach((className) => {
                this.conditionallySetHtmlClassState(this.isCollapsable, 'collapsable', {htmlClass: className});
                this.swapHtmlClassStates(this.isOpen, 'open', 'closed', {htmlClass: className});
            });
        }
    }

    toggleOpen(toggle) {
        this.isOpen = !this.isOpen;
    }

    getToggles() {
        const selector = this.getDatasetConfigValue('toggle_selector') || CollapserToggle.config.selector;
        const toggles = [];
        const toggleElements = this.element.querySelectorAll(selector);
        toggleElements.forEach((toggleElement) => {
            toggles.push(new CollapserToggle(toggleElement, this));
        });
        return toggles;
    }

    getTarget() {
        const selector = this.getDatasetConfigValue('target_selector') || CollapserToggle.config.selector;
        const targetElement = this.element.querySelector(selector);
        if (targetElement == null) return null;
        return new CollapserTarget(targetElement, this);
    }

}



